'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Line(text, accent) {
  this.ff = null;
  this.hw = false;
  this.ff = text;
  this.hw = accent;
}
export { $c_Lio_intela_sites_intelacloud_content_Line as $c_Lio_intela_sites_intelacloud_content_Line };
$p = $c_Lio_intela_sites_intelacloud_content_Line.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Line;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Line() {
}
export { $h_Lio_intela_sites_intelacloud_content_Line as $h_Lio_intela_sites_intelacloud_content_Line };
$h_Lio_intela_sites_intelacloud_content_Line.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().l(acc, 2368532);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().l(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().R(this.ff));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().l(acc, (this.hw ? 1231 : 1237));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().N(acc, 2);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Line) && ((this.hw === x$0.hw) && (this.ff === x$0.ff))));
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "Line";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.ff;
  }
  if ((n === 1)) {
    return this.hw;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Line(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.by)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Line as $isArrayOf_Lio_intela_sites_intelacloud_content_Line };
var $d_Lio_intela_sites_intelacloud_content_Line = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Line, "io.intela.sites.intelacloud.content.Line", ({
  by: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Line as $d_Lio_intela_sites_intelacloud_content_Line };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Line.js.map
